import { render, staticRenderFns } from "./AccaOnMiniBetslip.vue?vue&type=template&id=663b570d"
import script from "./AccaOnMiniBetslip.vue?vue&type=script&lang=js"
export * from "./AccaOnMiniBetslip.vue?vue&type=script&lang=js"
import style0 from "./AccaOnMiniBetslip.vue?vue&type=style&index=0&id=663b570d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports